import { ManagementHistory } from 'components/managementHistory/ManagementHistory'

export const ManagementPage = () => {
  return <ManagementHistory />
}
